export interface AgentState {
  state: string;
  reason: string;
  isACW?: boolean;
}

export interface AgentCurrentState extends AgentState {
  startTime: number;
  acwTimeout: number;
}
